import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle, Phone, Clock, UserCheck, FileText, Download } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function ConfirmationPage() {
  return (
    <>
      <Header />
      <main className="min-h-screen bg-[#FCFCFA] pt-24" data-testid="confirmation-page">
        <div className="max-w-2xl mx-auto px-6 py-20 text-center">
          <div className="w-20 h-20 mx-auto mb-8 bg-[#163321]/10 rounded-full flex items-center justify-center animate-fade-in-up">
            <CheckCircle className="w-10 h-10 text-[#163321]" />
          </div>

          <h1 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight text-[#0F1F14] mb-6 animate-fade-in-up animation-delay-100">
            Richiesta Inviata
          </h1>

          <p className="text-base text-[#4A5E51] leading-relaxed mb-10 max-w-lg mx-auto animate-fade-in-up animation-delay-200">
            Abbiamo ricevuto la tua richiesta. Un consulente dedicato ti contatter&agrave;
            entro 24 ore per discutere la soluzione pi&ugrave; adatta alle tue esigenze.
          </p>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-12">
            <div className="bg-white rounded-2xl border border-[#E5E2DB] p-6 animate-fade-in-up animation-delay-200">
              <Clock className="w-8 h-8 text-[#D97B58] mx-auto mb-3" />
              <p className="text-sm font-medium text-[#0F1F14]">Entro 24 ore</p>
              <p className="text-xs text-[#4A5E51] mt-1">Tempo di risposta</p>
            </div>
            <div className="bg-white rounded-2xl border border-[#E5E2DB] p-6 animate-fade-in-up animation-delay-300">
              <UserCheck className="w-8 h-8 text-[#D97B58] mx-auto mb-3" />
              <p className="text-sm font-medium text-[#0F1F14]">Consulente Dedicato</p>
              <p className="text-xs text-[#4A5E51] mt-1">Non un sistema automatico</p>
            </div>
            <div className="bg-white rounded-2xl border border-[#E5E2DB] p-6 animate-fade-in-up animation-delay-400">
              <Phone className="w-8 h-8 text-[#D97B58] mx-auto mb-3" />
              <p className="text-sm font-medium text-[#0F1F14]">081 761 1000</p>
              <p className="text-xs text-[#4A5E51] mt-1">Per urgenze</p>
            </div>
          </div>

          <p className="text-sm text-[#4A5E51] mb-10 italic" data-testid="human-touch-message">
            "Parlerai con un consulente reale, non con un sistema automatico"
          </p>

          {/* Policy download section */}
          <div className="bg-[#F5F4F0] rounded-2xl border border-[#E5E2DB] p-6 mb-10 animate-fade-in-up animation-delay-400" data-testid="policy-download-section">
            <div className="flex items-center justify-center gap-2 mb-3">
              <FileText className="w-5 h-5 text-[#163321]" />
              <p className="text-sm font-medium text-[#0F1F14]">Informativa sul trattamento dei dati</p>
            </div>
            <p className="text-xs text-[#4A5E51] mb-4">
              I tuoi dati sono trattati nel rispetto del GDPR. Puoi consultare e scaricare le nostre policy:
            </p>
            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link to="/privacy" className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-white border border-[#E5E2DB] text-sm text-[#163321] hover:bg-[#163321]/5 transition-colors" data-testid="download-privacy-link">
                <Download className="w-4 h-4" /> Privacy Policy
              </Link>
              <Link to="/cookie-policy" className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-xl bg-white border border-[#E5E2DB] text-sm text-[#163321] hover:bg-[#163321]/5 transition-colors" data-testid="download-cookie-link">
                <Download className="w-4 h-4" /> Cookie Policy
              </Link>
            </div>
          </div>

          <Button asChild className="rounded-full px-8 h-12 bg-[#163321] text-white hover:bg-[#224A32] text-sm font-medium">
            <Link to="/" data-testid="back-home-btn">Torna alla Home</Link>
          </Button>
        </div>
      </main>
      <Footer />
    </>
  );
}
